import { makeStyles } from '@fluentui/react-components';
import { useRouteContext } from '@tanstack/react-router';

const useStyles = makeStyles({
    root: {
        backgroundColor: 'var(--colorNeutralBackground4)',
        display: 'grid',
        gridTemplateColumns: '1fr 2fr 1fr',
        padding: 'var(--spacingHorizontalMNudge)',
    },
    left: {
        justifySelf: 'start',
    },
    center: {
        justifySelf: 'center',
    },
    right: {
        justifySelf: 'end',
    },
});

export const Footer = () => {
    const styles = useStyles();

    return (
        <footer className={styles.root}>
            <div className={styles.left}>
                <img
                    src="/favicon.svg"
                    alt="Favicon"
                    style={{ height: 24, verticalAlign: 'middle', marginRight: 8 }}
                />
                <b>Version:</b> {import.meta.env.APP_VERSION}
            </div>

            <div className={styles.center}>
                <SiteInfo />
            </div>

            <div className={styles.right} />
        </footer>
    );
};

const SiteInfo = () => {
    const siteName = useRouteContext({
        from: '__root__',
        select: (context) => context.site?.siteUrl,
    });
    return (
        siteName && (
            <>
                <b>Aktuelle Seite:</b> {siteName}
            </>
        )
    );
};
